<input hidden [value]="(selectedItem$ | async)?.getSelectionTitle()" [attr.id]="controlId" [attr.name]="name" />

<!-- Desktop -->
<div
  #desktopDropdown
  [hidden]="isMobile$ | async"
  class="reactive-form-input reactive-form-html-dropdown"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-labelledby]="labelId"
  [attr.aria-controls]="listboxId"
  [attr.aria-expanded]="!!(showDropdown$ | async)"
  [attr.aria-activedescendant]="
    (showDropdown$ | async)
      ? ((interactiveItems$ | async)?.[highlightedIndex] | dropdownOptionId : listboxId : dropdowns)
      : null
  "
  [attr.aria-disabled]="disabled"
  [attr.aria-invalid]="error"
  [class.form-error-border]="error"
  [class.disabled]="disabled"
  [class.dropdown-open]="showDropdown$ | async"
  [class.placeholder-selected]="!(selectedItem$ | async)"
  (click)="toggleDropdown()"
  [attr.contenteditable]="false"
  [attr.tabindex]="disabled ? -1 : 0">
  {{ (selectedItem$ | async)?.getSelectionTitle() || placeholder }}
</div>

<div
  class="dropdown-content"
  role="listbox"
  [attr.id]="listboxId"
  [attr.aria-labelledby]="labelId"
  [hidden]="!(showDropdown$ | async) || isMobile"
  (mousedown)="$event.preventDefault()"
  #dropdownContent>
  <!-- selectedItem$/interactiveItems$ are resolved once here rather than per option: a long list
       (e.g. every country) would otherwise hold three async pipe subscriptions per row. -->
  <ng-container
    *ngIf="{ selectedItem: selectedItem$ | async, interactiveItems: interactiveItems$ | async } as dropdownState">
    <div
      class="dropdown-item clearable"
      role="option"
      aria-selected="false"
      *ngIf="clearable && !disabled && dropdownState.selectedItem"
      [attr.id]="'reset' | dropdownOptionId : listboxId : dropdowns"
      (click)="resetInput(); closeDropdown()"
      [class.highlighted]="clearable && highlightedIndex === 0"
      i18n>
      Reset
    </div>
    <ng-container *ngFor="let group of groups; trackBy: trackByGroupLabel">
      <div class="dropdown-header" aria-hidden="true" *ngIf="group.label">{{ group.label }}</div>
      <button
        type="button"
        class="dropdown-item"
        role="option"
        tabindex="-1"
        *ngFor="let item of group.items; trackBy: trackByValue"
        [attr.id]="item | dropdownOptionId : listboxId : dropdowns"
        [attr.aria-selected]="item.getSelectionValue() === dropdownState.selectedItem?.getSelectionValue()"
        (click)="itemSelected(item)"
        [class.grouped]="!!group.label"
        [class.disabled]="item.getSelectionIsDisabled()"
        [class.selected]="item.getSelectionValue() === dropdownState.selectedItem?.getSelectionValue()"
        [class.highlighted]="item | dropdownItemHighlighted : highlightedIndex : dropdownState.interactiveItems"
        [disabled]="item.getSelectionIsDisabled()">
        <img
          *ngIf="item.getSelectionValue() === dropdownState.selectedItem?.getSelectionValue()"
          class="icon-img"
          src="assets/icons/typeahead/Check.svg"
          alt="" />
        {{ item.getSelectionTitle() }}
      </button>
    </ng-container>
  </ng-container>
</div>

<!-- Mobile -->
<select
  *ngIf="isMobile$ | async"
  class="reactive-form-input reactive-form-html-dropdown"
  [disabled]="disabled"
  [value]="(selectedItem$ | async)?.getSelectionValue() ?? ''"
  [ngClass]="{ 'placeholder-selected': !(selectedItem$ | async)?.getSelectionValue() }"
  (change)="onSelectChanged($event)">
  <option value="" disabled>
    {{ placeholder }}
  </option>
  <ng-container *ngFor="let group of groups; trackBy: trackByGroupLabel">
    <optgroup *ngIf="group.label" [label]="group.label">
      <option
        *ngFor="let drop of group.items; trackBy: trackByValue"
        [value]="drop.getSelectionValue()"
        [disabled]="drop.getSelectionIsDisabled()">
        {{ drop.getSelectionTitle() }}
      </option>
    </optgroup>
    <ng-container *ngIf="!group.label">
      <option
        *ngFor="let drop of group.items; trackBy: trackByValue"
        [value]="drop.getSelectionValue()"
        [disabled]="drop.getSelectionIsDisabled()">
        {{ drop.getSelectionTitle() }}
      </option>
    </ng-container>
  </ng-container>
</select>
